module.exports = __webpack_public_path__ + "static/team-fd8634cb6d3348b63f6250c4ea2fb09a.jpg";